import {
  ChartLineIcon,
  CheckListIcon,
  DevicesIcon,
  DocSearchIcon,
  FinancingIcon,
  HalfDataIcon,
  JoyStickIcon,
  ListViewIcon,
  MapIcon,
  RemoteControlIcon,
  TableReportIcon,
  UserIcon,
} from '@/components/icons'
import EditCalendar from '@/components/icons/EditCalendar'
import MoreAppIcon from '@/components/icons/MoreAppIcon'
import PageTemplateIcon from '@/components/icons/PageTemplateIcon'
import TreeListIcon from '@/components/icons/TreeListIcon'
import { CONFIG_ROUTES, OPERATIONS_ROUTES } from '@/constant/route'

import { useAuthContext } from '@features/auth/context'

import {
  DynamicDashboardAccess,
  ZeusDashboardAccess,
} from 'constant/featureAccessRestriction'

export const getMenuMain = (
  t: (key: string) => string,
  interfaceId?: number,
) => [
  {
    link: OPERATIONS_ROUTES.mapview.to,
    icon: <MapIcon />,
    label: t('menuOperationsMapView'),
    disabled: false,
  },
  {
    link: OPERATIONS_ROUTES.programs.to,
    icon: <ListViewIcon />,
    label: t('menuOperationsPrograms'),
    disabled: false,
  },
  {
    link: OPERATIONS_ROUTES.savedComparison.to,
    icon: <ListViewIcon />,
    label: t('Saved Comparisons'),
    disabled: false,
  },
  {
    link: OPERATIONS_ROUTES.dynamicDashboard.to,
    icon: <ListViewIcon />,
    label: t('menuOperationsDynamicDashboard'),
    disabled: interfaceId ? !DynamicDashboardAccess.includes(interfaceId) : true,
  },
  {
    link: OPERATIONS_ROUTES.irrigationOverview.to,
    icon: <TableReportIcon />,
    label: t('menuOperationsIrrigationOverview'),
    disabled: false,
  },
  {
    link: OPERATIONS_ROUTES.programSchedule.to,
    icon: <EditCalendar fill="#8A8A8A" />,
    label: t('menuOperationsProgramSchedule'),
    disabled: true,
  },

  {
    link: OPERATIONS_ROUTES.manualRun.to,
    icon: <JoyStickIcon />,
    label: t('menuOperationsManualRun'),
    disabled: true,
  },
  {
    link: OPERATIONS_ROUTES.simulation.to,
    icon: <ChartLineIcon />,
    label: t('menuOperationsSimulation'),
    disabled: false,
  },
  {
    link: OPERATIONS_ROUTES.flowHistory.to,
    icon: <TreeListIcon />,
    label: t('menuOperationsFlowHistory'),
    disabled: false,
  },
  // {
  //   link: OPERATIONS_ROUTES.stations.to,
  //   icon: <DevicesIcon />,
  //   label: ' Stations',
  //   disabled: false,
  // },

  {
    link: OPERATIONS_ROUTES.sensors.to,
    icon: <MoreAppIcon />,
    label: t('menuOperationsSpecialOperations'),
    disabled: true,
  },
]
// Pure function: safe to call anywhere
export const getMenuSensors = (
  t: (key: string) => string,
  interfaceId?: number,
) => {
  const shouldShowZeusDashboard = interfaceId
    ? ZeusDashboardAccess.includes(interfaceId)
    : false

  const menu = []

  menu.push({
    link: OPERATIONS_ROUTES.sensors.to,
    icon: <PageTemplateIcon />,
    label: t('menuSensorsSensorsDashboard'),
    disabled: false,
  })
  shouldShowZeusDashboard &&
    menu.push({
      link: OPERATIONS_ROUTES.zeusDashboard.to,
      icon: <PageTemplateIcon />,
      label: t('menu.parklandDashboard'),
      disabled: false,
    })
  menu.push({
    link: CONFIG_ROUTES.etz.to,
    icon: <FinancingIcon />,
    label: t('menuSensorsMicroClimate'),
    disabled: false,
  })
  menu.push({
    link: OPERATIONS_ROUTES.scadaDashboard.to,
    icon: <FinancingIcon />,
    label: t('Scada Dashboard'),
    disabled: false,
  })
  return menu
}

export const getMenuStationConfig = (t: (key: string) => string) => [
  {
    link: CONFIG_ROUTES.stations.to,
    icon: <DevicesIcon />,
    label: t('menuStationConfigStations'),
    disabled: false,
  },
  {
    link: CONFIG_ROUTES.controllers.to,
    icon: <RemoteControlIcon />,
    label: t('menuStationConfigDecoders'),
    disabled: false,
  },
  // Areas & Sub-Areas is no longer a standalone menu item — it lives inside the
  // Data Configuration → Plant / Soil / Emitter tab as a fourth column.
]

export const getMenuDataConfig = (t: (key: string) => string) => {
  const menu = [
    {
      link: CONFIG_ROUTES.dataConfig.to,
      icon: <HalfDataIcon />,
      label: t('menuDataConfigDataConfiguration'),
      disabled: false,
    },
  ]

  return menu
}

export const getMenuOther = (t: (key: string) => string) => [
  {
    link: OPERATIONS_ROUTES.diagnostics.to,
    icon: <CheckListIcon />,
    label: t('menuOtherDiagnosis'),
    disabled: false,
  },
  // {
  //   link: OPERATIONS_ROUTES.activities.to,
  //   icon: <WorkBenchIcon />,
  //   label: ' Activity',
  //   disabled: false,
  // },
  {
    link: OPERATIONS_ROUTES.reports.to,
    icon: <DocSearchIcon />,
    label: t('menuOtherReports'),
    disabled: false,
  },
  {
    link: OPERATIONS_ROUTES.userManagement.to,
    icon: <UserIcon />,
    label: t('menuOtherUserManagement'),
    disabled: true,
  },
]
